"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useArchiveOneMutation = exports.useTreatOneMutation = exports.useMarkReadMutation = exports.useListUntraitedQuery = exports.useListUnreadQuery = exports.sosApi = exports.prepareHeaders = void 0;
const react_1 = require("@reduxjs/toolkit/query/react");
const http_1 = require("../../http");
const storage_1 = require("../../storage");
// =============================================================
// A) RTK QUERY: API service + store + wrapper (endpoints fournis)
// =============================================================
const prepareHeaders = (headers, { getState }) => {
    var _a, _b;
    const token = (_a = getState().user.token) !== null && _a !== void 0 ? _a : (_b = storage_1.AppStorage.getItem("user")) === null || _b === void 0 ? void 0 : _b.token;
    if (token) {
        headers.set("Authorization", `Bearer ${token}`);
    }
    return headers;
};
exports.prepareHeaders = prepareHeaders;
exports.sosApi = (0, react_1.createApi)({
    reducerPath: 'sosApi',
    baseQuery: (0, react_1.fetchBaseQuery)({
        baseUrl: `${http_1.ApiBaseUrl}`,
        prepareHeaders: exports.prepareHeaders,
    }),
    tagTypes: ['SosTow', 'SosList'],
    endpoints: (b) => ({
        // Listes basées sur tes endpoints
        listUnread: b.query({
            query: () => ({ url: 'getUnreadSOSTowings', method: 'GET' }),
            transformResponse: (res) => { var _a; return Array.isArray(res) ? res : ((_a = res === null || res === void 0 ? void 0 : res.data) !== null && _a !== void 0 ? _a : []); },
            providesTags: (result) => result ? [
                ...result.map(r => ({ type: 'SosTow', id: r.id })),
                { type: 'SosList', id: 'UNREAD' }
            ] : [{ type: 'SosList', id: 'UNREAD' }]
        }),
        listUntraited: b.query({
            query: () => ({ url: 'getUntraitedSOSTowings', method: 'GET' }),
            transformResponse: (res) => { var _a; return Array.isArray(res) ? res : ((_a = res === null || res === void 0 ? void 0 : res.data) !== null && _a !== void 0 ? _a : []); },
            providesTags: (result) => result ? [
                ...result.map(r => ({ type: 'SosTow', id: r.id })),
                { type: 'SosList', id: 'UNTRAITED' }
            ] : [{ type: 'SosList', id: 'UNTRAITED' }]
        }),
        // Actions unitaires
        markRead: b.mutation({
            query: (id) => ({ url: `getReadSOSTowing/${id}`, method: 'POST' }),
            invalidatesTags: (r, e, id) => [{ type: 'SosTow', id }, { type: 'SosList', id: 'UNREAD' }, { type: 'SosList', id: 'UNTRAITED' }]
        }),
        treatOne: b.mutation({
            query: (id) => ({ url: `treat-sos-towing/${id}`, method: 'POST' }),
            invalidatesTags: (r, e, id) => [{ type: 'SosTow', id }, { type: 'SosList', id: 'UNREAD' }, { type: 'SosList', id: 'UNTRAITED' }]
        }),
        archiveOne: b.mutation({
            query: (id) => ({ url: `archive-sos-towing/${id}`, method: 'POST' }),
            invalidatesTags: (r, e, id) => [{ type: 'SosTow', id }, { type: 'SosList', id: 'UNREAD' }, { type: 'SosList', id: 'UNTRAITED' }]
        }),
    })
});
exports.useListUnreadQuery = exports.sosApi.useListUnreadQuery, exports.useListUntraitedQuery = exports.sosApi.useListUntraitedQuery, exports.useMarkReadMutation = exports.sosApi.useMarkReadMutation, exports.useTreatOneMutation = exports.sosApi.useTreatOneMutation, exports.useArchiveOneMutation = exports.sosApi.useArchiveOneMutation;
// export function NotificationsSOS_RTK() {
//   const unread = useListUnreadQuery();
//   const untraited = useListUntraitedQuery();
//   const merge = (a: DbTow[] = [], b: DbTow[] = []) => {
//     const map = new Map<number, DbTow>();
//     [...a, ...b].forEach(it => map.set(it.id, it));
//     return Array.from(map.values());
//   };
//   const data = merge(unread.data, untraited.data);
//   const items = useMemo(() => data.map(mapTowToNotif), [data]);
//   const [markRead] = useMarkReadMutation();
//   const [treatOne] = useTreatOneMutation();
//   const [archiveOne] = useArchiveOneMutation();
//   const onMarkAllRead = async () => {
//     const news = items.filter(i => i.status === 'NOUVEAU');
//     await Promise.all(news.map(n => markRead(n.id)));
//     unread.refetch();
//     untraited.refetch();
//   };
//   const onDeleteRead = async () => { // pas d'endpoint delete-read: on archive les LUS
//     const lus = items.filter(i => i.status === 'LU');
//     await Promise.all(lus.map(n => archiveOne(n.id)));
//     unread.refetch();
//     untraited.refetch();
//   };
//   const onMarkTraite = async (id: number) => { await treatOne(id); unread.refetch(); untraited.refetch(); };
//   const onArchive = async (id: number) => { await archiveOne(id); unread.refetch(); untraited.refetch(); };
//   return (
//     <Provider store={rtkStore}>
//       <NotificationsSOSView
//         items={items}
//         onMarkAllRead={onMarkAllRead}
//         onDeleteRead={onDeleteRead}
//         onMarkTraite={onMarkTraite}
//         onArchive={onArchive}
//       />
//     </Provider>
//   );
// }
